const ROUTES = {
  "/": {
    "name": "HomePage6f1d5dbf094145f189b4B6fb76f47707",
    "type": "HTML",
    "key": "home-page"
  },
  "/about": {
    "name": "AboutUsPage9acd145096904b2fAd7a7c2710eef3f7",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/apply/*": {
    "name": "ApplicationPages7c8f73c503af4cbfB467A544f2b7af0e",
    "type": "REFERENCE",
    "key": "application-pages"
  },
  "/events/public": {
    "name": "PublicEventsPage2883bd145fa046849e239ec4d007d92e",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/join": {
    "name": "JoinUsPage7bea41884bb34087A9df5fa26d578ba9",
    "type": "REFERENCE",
    "key": "join-us-page"
  }
};

export default ROUTES;